import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { useState } from "react";
import Container from "./Container";
import "../../index.css";
import "../../fonts.css";
import "../../styles/landing.css";
import "../../styles/public-pages.css";
import { useAuth } from "../../hooks/useAuth";
import LanguageToggle from "./LanguageToggle";
import { useT } from "../../i18n/useT";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const t = useT();
  const hasPublicStyle = ["/", "/contact", "/inloggen", "/checkout"].includes(
    location.pathname,
  );

  function handleBestellenClick() {
    setOpen(false);
    navigate("/checkout?category=auto&product=auto-deluxe");
  }

  if (
    location.pathname.startsWith("/app") ||
    location.pathname.startsWith("/quiz")
  ) {
    return null;
  }

  return (
    <header
      className={`${hasPublicStyle ? "home-navbar " : ""}sticky top-0 z-50 border-b border-neutral-200 bg-white/80 backdrop-blur dark:border-neutral-800 dark:bg-neutral-950/85`}
    >
      <Container className="flex items-center justify-between h-16">
        {/* <Link to="/" className="font-display text-5xl" style={{color: "orange"}}>THEORIE101</Link> */}
        <Link
          to="/"
          className={
            hasPublicStyle ? "home-navbar-logo" : "poppins-bold text-5xl"
          }
          style={
            hasPublicStyle
              ? undefined
              : {
                  background:
                    "linear-gradient(90deg, #FF8C00, #8A421CFF, #F74808FF, #FF8C00)",
                  backgroundSize: "300% 100%",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  animation: "gradientMove 4s ease infinite",
                  textDecoration: "none",
                  display: "inline-block",
                  padding: "0.25rem",
                }
          }
        >
          THEORIE101
        </Link>
        <nav className="hidden items-center gap-6 text-neutral-700 dark:text-neutral-200 md:flex">
          {/* <NavLink to="/faq">FAQ</NavLink> */}
          {/* <NavLink to="/blog">Blog</NavLink> */}
          <NavLink to="/contact">{t.nav.contact}</NavLink>
          {/* <NavLink to="/inloggen">Inloggen</NavLink> */}
          {isAuthenticated ? (
            <>
              <NavLink to="/app/oefenexamens">{t.nav.dashboard}</NavLink>
              <button onClick={logout}>{t.nav.logout}</button>
            </>
          ) : (
            <NavLink to="/inloggen">{t.nav.login}</NavLink>
          )}

          <button
            type="button"
            onClick={handleBestellenClick}
            className="font-medium text-gray-700 transition hover:text-gray-950 dark:text-neutral-200 dark:hover:text-white"
          >
            {t.nav.order}
          </button>
          <LanguageToggle />
        </nav>
        <button
          className="text-neutral-800 dark:text-neutral-100 md:hidden"
          onClick={() => setOpen(!open)}
          aria-label={t.nav.menu}
        >
          <Menu />
        </button>
      </Container>
      {open && (
        <div className="border-t border-neutral-200 bg-white dark:border-neutral-800 dark:bg-neutral-950 md:hidden">
          <Container className="flex flex-col gap-4 py-4 text-neutral-700 dark:text-neutral-200">
            {/* <NavLink to="/faq" onClick={() => setOpen(false)}>FAQ</NavLink> */}
            {/* <NavLink to="/blog" onClick={() => setOpen(false)}>Blog</NavLink> */}
            <NavLink to="/contact" onClick={() => setOpen(false)}>
              {t.nav.contact}
            </NavLink>
            {isAuthenticated ? (
              <>
                <NavLink to="/app/oefenexamens" onClick={() => setOpen(false)}>
                  {t.nav.dashboard}
                </NavLink>
                <button
                  onClick={() => {
                    logout();
                    setOpen(false);
                  }}
                >
                  {t.nav.logout}
                </button>
              </>
            ) : (
              <NavLink to="/inloggen" onClick={() => setOpen(false)}>
                {t.nav.login}
              </NavLink>
            )}
            <button
              type="button"
              onClick={handleBestellenClick}
              className="w-fit font-medium text-gray-700 transition hover:text-gray-950 dark:text-neutral-200 dark:hover:text-white"
            >
              {t.nav.order}
            </button>
            <LanguageToggle />
          </Container>
        </div>
      )}
    </header>
  );
}
